import { toolIcon } from '../../lib/toolMeta';

/** A tool's lucide mark: the daemon-declared emoji is translated by `toolIcon`'s closed table, an absent
 *  declaration falls back to the core-owned mark or the neutral wrench. Decoration only. */
export function ToolMark({ name, icon }: { name: string; icon?: string | null }) {
  const Glyph = toolIcon(name, icon);
  return <Glyph size={12} aria-hidden className="shrink-0" />;
}
